import { render, staticRenderFns } from "./titles.vue?vue&type=template&id=1ba9d6e6&scoped=true&"
import script from "./titles.vue?vue&type=script&lang=js&"
export * from "./titles.vue?vue&type=script&lang=js&"
import style0 from "./titles.vue?vue&type=style&index=0&id=1ba9d6e6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9d6e6",
  null
  
)

export default component.exports